import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  DeleteInvoice,
  DeleteInvoiceCancel,
  DeleteInvoiceFailed,
  DeleteInvoiceSuccess,
} from '../actions/delete-invoice.actions';
import { CancelInfoInvoice, CancelInfoInvoiceSuccess } from '../actions/invoice-info.actions';

export interface DeleteInvoiceState {
  invoiceId: number;
  memberAvailableBalance: number;
  pointsToBeDeleted: number;
  memberNewBalance: number;
  userSearched: boolean;
}

const initialState: DeleteInvoiceState = {
  invoiceId: 0,
  memberAvailableBalance: 0,
  pointsToBeDeleted: 0,
  memberNewBalance: 0,
  userSearched: false,
};

export const DeleteInvoiceReducer = createReducer(
  initialState,
  on(CancelInfoInvoice, (state, { invoiceId }) => ({
    ...state,
    invoiceId,
  })),
  on(DeleteInvoice, (state) => ({
    ...state,
    userSearched: true,
  })),
  on(DeleteInvoiceSuccess, DeleteInvoiceFailed, (state) => ({
    ...state,
    userSearched: false,
  })),
  on(CancelInfoInvoiceSuccess, (state, { res }) => ({
    ...state,
    memberAvailableBalance: res.memberAvailableBalance,
    pointsToBeDeleted: res.pointsToBeDeleted,
    memberNewBalance: res.memberNewBalance,
  })),
  on(DeleteInvoiceCancel, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
